<template>
  <div class="columns">
    <div class="column is-one-quarter">
      <b-upload drag-drop v-model="images" v-if="imageId === null">
        <section class="section">
          <div class="content has-text-centered">
            <p>Drop your files here or click to upload</p>
          </div>
        </section>
      </b-upload>
      <div class="image is-square" v-else>
        <img :src="BASE_URL + '/images/' + imageId + '/mid'">
      </div>
      <button type="button" class="button" v-if="imageId !== null" @click="imageId = null">Change Image</button>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '../../http';
import { HTTP } from '../../http';

export default {
  name: 'image-upload',

  props: ['imageid'],

  data() {
    return {
      images: null,
      imageId: null,
      uploading: false,
      progress: null,
      BASE_URL,
    };
  },

  mounted() {
    this.$store.dispatch('image/getCode');

    if (this.imageid !== undefined && this.imageid !== null) {
      this.imageId = this.imageid;
    }
  },

  watch: {
    images() {
      // console.log(this.images);

      let data = new FormData();
      data.append('image', this.images[0]);
      data.append('upload_code', this.uCode);

      this.uploadFile(data);
    },

    imageid() {
      if (this.imageid !== undefined && this.imageid !== null) {
        this.imageId = this.imageid;
      }
    },
  },

  methods: {
    uploadFile(data) {
      this.uploading = true;

      HTTP.post('/images/upload', data)
        .then((resp) => {
          // console.log(resp.data);
          // this.imageId = resp.data.id;
          this.$emit('uploaded', resp.data.id);
        })
        .catch((err) => console.log(err.response));
    },
  },

  computed: {
    uCode() {
      return this.$store.state.image.upload_code;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/ImageUpload.vue